import type { LayerDef } from "./types";
import { priceLayers } from "./layers/prices";
import { salesLayer } from "./layers/sales";
import { transitLayer } from "./layers/transit";
import { greenLayer } from "./layers/green";
import { airLayer, noiseLayer } from "./layers/airnoise";
import { demographicsLayer } from "./layers/demographics";
import { catnatLayer, clayLayer } from "./layers/risks";
import { climateGridLayer, firesLayer, heatIslandLayer } from "./layers/climate";

/**
 * Every togglable data layer in the app.
 *
 * The map, the layer panel and the legend are all driven off this list, so
 * adding a layer is a matter of appending a definition — no changes to the map
 * component.
 *
 * Array position is draw order: every layer is inserted before the same anchor,
 * so later entries sit on top of earlier ones. The hazard and climate layers go
 * above the price choropleth and below transit, because transit is the one
 * layer people navigate by and it has to stay readable through anything.
 */
export const LAYER_REGISTRY: LayerDef[] = [
  priceLayers,
  salesLayer,
  demographicsLayer,
  catnatLayer,
  climateGridLayer,
  firesLayer,
  noiseLayer,
  airLayer,
  greenLayer,
  heatIslandLayer,
  clayLayer,
  transitLayer,
];

export function layerById(id: string): LayerDef | undefined {
  return LAYER_REGISTRY.find((l) => l.id === id);
}
